import React from 'react'

export default function Team() {
  return (
    <div className="container-xxl py-5">
        <div className="container py-5">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="text-secondary text-uppercase">Happy Drivers</h6>
                <h1 className="mb-5">100+ orders delivered</h1>
            </div>
            <div className="row g-4">
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div className="team-item p-4">
                        <div className="overflow-hidden mb-4">
                            <img className="img-fluid" src="/assets/img/team-1.jpg" alt="" />
                        </div>
                        <h5 className="mb-0">Ashok</h5>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="team-item p-4">
                        <div className="overflow-hidden mb-4">
                            <img className="img-fluid" src="/assets/img/team-2.jpg" alt="" />
                        </div>
                        <h5 className="mb-0">Krushna</h5>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                    <div className="team-item p-4">
                        <div className="overflow-hidden mb-4">
                            <img className="img-fluid" src="/assets/img/team-3.jpg" alt="" />
                        </div>
                        <h5 className="mb-0">Mukesh</h5>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.9s">
                    <div className="team-item p-4">
                        <div className="overflow-hidden mb-4">
                            <img className="img-fluid" src="/assets/img/team-4.jpg" alt="" />
                        </div>
                        <h5 className="mb-0">Rahul</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
